import React, { useState } from 'react';

const McqView = ({ mcqs, answers, setAnswers, paperId }) => {
    const handleAnswerSelect = (questionIndex, selectedAnswer) => {
        setAnswers(prev => ({
            ...prev,
            [paperId]: {
                ...prev[paperId],
                [questionIndex]: selectedAnswer
            }
        }));
    };

    const calculateScore = () => {
        if (!answers[paperId]) return { correct: 0, total: 0 };

        const attempted = Object.keys(answers[paperId]).length;
        const correct = Object.entries(answers[paperId]).reduce((acc, [index, answer]) => {
            return acc + (answer === mcqs[index].answer ? 1 : 0);
        }, 0);

        return { correct, total: attempted };
    };

    const handleReset = () => {
        setAnswers(prev => ({
            ...prev,
            [paperId]: {}
        }));
    };

    if (!mcqs || mcqs.length === 0) {
        return (
            <div className="h-full flex items-center justify-center">
                <p className="text-gray-400">No practice questions available for this paper.</p>
            </div>
        );
    }

    const score = calculateScore();

    return (
        <div className="max-w-3xl mx-auto p-6 space-y-8">
            <div className="bg-purple-900/20 rounded-lg border border-purple-900/30 p-4">
                <div className="flex items-center justify-between">
                    <p className="text-lg text-gray-200">
                        Score: <span className="text-purple-400 font-bold">{score.correct}</span> / <span className="text-gray-400">{score.total}</span>
                        {score.total > 0 && (
                            <span className="text-sm text-gray-400 ml-2">
                                ({Math.round((score.correct / score.total) * 100)}%)
                            </span>
                        )}
                    </p>
                    <button
                        onClick={handleReset}
                        className="px-4 py-2 text-sm text-purple-300 hover:text-purple-200 bg-purple-900/30 hover:bg-purple-900/40 rounded-lg border border-purple-900/30 transition-all duration-200"
                    >
                        Reset Answers
                    </button>
                </div>
            </div>

            {mcqs.map((mcq, index) => {
                const currentAnswer = answers[paperId]?.[index];
                const isCorrect = currentAnswer === mcq.answer;
                const hasAnswered = currentAnswer !== undefined;

                return (
                    <div key={index} className="bg-purple-900/10 rounded-lg border border-purple-900/20 p-6">
                        <h3 className="text-lg font-medium text-white mb-4">
                            {index + 1}. {mcq.question}
                        </h3>
                        <div className="space-y-3">
                            {mcq.options.map((option, optionIndex) => {
                                const isSelected = currentAnswer === option;
                                const isCorrectAnswer = option === mcq.answer;

                                let buttonClass = "w-full text-left p-3 rounded-lg transition-all duration-200 ";

                                if (hasAnswered) {
                                    if (isSelected && isCorrect) {
                                        buttonClass += "bg-green-500/20 text-green-300 border border-green-500/30";
                                    } else if (isSelected && !isCorrect) {
                                        buttonClass += "bg-red-500/20 text-red-300 border border-red-500/30";
                                    } else if (isCorrectAnswer) {
                                        buttonClass += "bg-green-500/20 text-green-300 border border-green-500/30";
                                    } else {
                                        buttonClass += "bg-purple-900/20 text-gray-400 border border-purple-900/30";
                                    }
                                } else {
                                    buttonClass += "bg-purple-900/20 text-gray-300 border border-purple-900/30 hover:bg-purple-900/30";
                                }

                                return (
                                    <button
                                        key={optionIndex}
                                        onClick={() => !hasAnswered && handleAnswerSelect(index, option)}
                                        disabled={hasAnswered}
                                        className={buttonClass}
                                    >
                                        {option}
                                    </button>
                                );
                            })}
                        </div>
                        {hasAnswered && (
                            <div className="mt-4 p-4 rounded-lg bg-purple-900/20 border border-purple-900/30">
                                <p className="text-sm text-gray-300">
                                    <span className="font-medium text-purple-400">Explanation: </span>
                                    {mcq.explanation}
                                </p>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default McqView; 